<template>
  <div class="isTxt" v-if="isTxt">
    <div
      class="file-item"
      v-for="(file, index) in fileList"
      :key="index"
      @click="handleDownload(file)"
    >
      <Document style="width: 20px; margin-right: 2px; color: #2e8fe4" />
      <span>{{ file.name }}</span>
    </div>
  </div>
  <RxkUploadFile
    v-else
    class="customUpload"
    :limit="limit"
    :maxSize="20"
    :fileList="list"
    list-type="text"
    @handleSuccess="handleSuccess"
    :accept="accept"
    :disabled="renderConfig.disabled"
    @handleRemove="handleRemove"
  >
    <template #upload>
      <div class="uploadImg" :class="{ 'forbidden-upload': renderConfig.disabled }">点击上传</div>
    </template>
  </RxkUploadFile>
</template>
<script lang="ts" setup>
import { computed, onMounted, ref, unref, watch } from 'vue'
import { basicProps } from '@/components/custom/form/components/props'
import { RxkUploadFile } from '@/components/common/RxkUploadFile'
import { operateListEnum } from '@/enums/preObjectManage'
import { Document } from '@element-plus/icons-vue'
import globalEnv from '@/configs'
import { picturePath } from '@/utils'

const props = defineProps({
  ...basicProps
})
const emit = defineEmits(['update:modelValue', 'blur'])

// const innerValue = computed({
//   get () {
//     return props.modelValue
//   },
//   set (newVal) {
//     console.log(newVal, 'newVal1')
//     emit('update:modelValue', newVal)
//   }
// })
const list = ref<Recordable[]>([])
onMounted(() => {
  list.value = props.modelValue || props.data.value || []
  console.log(list, 'list999878')
})

watch(
  () => list.value,
  () => {
    if (!list.value.length) {
      emit('update:modelValue', '')
    } else {
      emit('update:modelValue', JSON.stringify(list.value))
    }
  },
  {
    deep: true
  }
)

const fileList = computed(() => {
  return unref(list).map(item => {
    return {
      url: picturePath(item.path),
      name: item.name
    }
  })
})
const limit = computed(() => {
  console.log(props.data, 'pppp1')
  const columnOperateList = props.data.columnOperateList || []
  const current = columnOperateList.find(
    (item: Recordable) => item.code === operateListEnum.FILE_ONE
  )
  return current && current.value ? 1 : 10
})
const accept = computed(() => {
  const setting = props.data.setting ? JSON.parse(props.data.setting) : { web: {} }
  console.log(setting?.web?.enclosure || '', 'kjj')
  return setting?.web?.enclosure || ''
})
function handleSuccess(fileList, file, res) {
  console.log(fileList, file, res)
  res.data.forEach((item: Recordable) => {
    list.value.push({
      name: item.name,
      path: item.path
    })
  })
  emit('blur', JSON.stringify(list.value))
}
function handleRemove(fileList: any, file: any) {
  let path = file?.response?.data?.[0]?.path
  list.value.forEach((e, i) => {
    if (e.path === path) list.value.splice(i, 1)
  })
  emit('blur', JSON.stringify(list.value || ''))
}
function handleDownload(file: any) {
  console.log(file.url)
  console.log(picturePath(file.url), 'picturePath(file.url)')
  window.open(picturePath(file.url))
}
</script>
<style lang="scss" scoped>
.customUpload {
  width: 100%;
  :deep(.el-upload) {
    width: 100%;
  }
}
.uploadImg {
  height: 32px;
  line-height: 32px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  width: 100%;
  text-align: center;
  color: #5687ff;
}
.file-item {
  margin-right: 2px;
  padding: 5px 0;
  display: flex;
  align-items: center;
  color: #2e8fe4;
  justify-items: center;
  cursor: pointer;
}
.forbidden-upload {
  background-color: #f5f7fa;
  cursor: not-allowed;
}
</style>
